import { combineReducers } from '@reduxjs/toolkit'
import { communicationDocumentDownloadReducer, communicationsDataReducers } from '../slices'

export const mailboxReducers = combineReducers({
  communications: combineReducers({
    data: communicationsDataReducers,
    documentDownload: communicationDocumentDownloadReducer,
  }),
})
